module.exports = __webpack_public_path__ + "static/img/new-home-item4.8966494c.jpg";